import { DatasourcedWidgetMetadata } from '@/modules/ta/legacy/widget/models/metadata/DataSourcedWidgetMetadata';
import { AccountManagerDrawOption } from '@/modules/ta/legacy/widget/models/drawoptions/AccountManagerDrawOption';

export class AccountManagerWidgetMetadata extends DatasourcedWidgetMetadata {
  constructor(model = {}) {
    super(model);

    this.draw_options = new AccountManagerDrawOption(model.draw_options);
  }
}
